<template>
  <div id="app">
    <div>
      <b-navbar toggleable="sm" type="dark" variant="dark">
        <b-navbar-brand href="#" :to="{ name: 'Dashboard' }"
          >Home</b-navbar-brand
        >

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :to="{ name: 'Checkin' }" v-if="isAuthLv1 == true"
              >Check In</b-nav-item
            >
            <b-nav-item :to="{ name: 'Members' }" v-if="isAuthLv1 == true"
              >Members</b-nav-item
            >
            <b-nav-item :to="{ name: 'Sales' }" v-if="isAuthLv1 == true"
              >Sales</b-nav-item
            >
            <b-nav-item :to="{ name: 'Products' }" v-if="false"
              >Products</b-nav-item
            >
            <b-nav-item :to="{ name: 'Privates' }">Privates</b-nav-item>
            <b-nav-item :to="{ name: 'Reports' }">Reports</b-nav-item>
            <b-nav-item :to="{ name: 'GClasses' }" v-if="isAuthLv1 == true"
              >Classes</b-nav-item
            >
            <b-nav-item :to="{ name: 'Qrcodes' }" v-if="isAuthLv1 == true"
              >QRcode</b-nav-item
            >
            <b-nav-item :to="{ name: 'Misc' }" v-if="isAuthLv1 == true"
              >Misc</b-nav-item
            >
            <!--<b-nav-item :to="{ name: 'Test' }">Test</b-nav-item>-->
            <b-nav-item v-if="!isLoggedIn" :to="{ name: 'Home' }"
              >Sign-in</b-nav-item
            >
            <b-nav-item v-if="isLoggedIn" @click.prevent="logout"
              >Logout</b-nav-item
            >
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <router-view />
    <div class="container">
      <div class="row justify-content-center"></div>
    </div>
  </div>
</template>

<script>
import { isAuthLv1, isAuthLv2 } from "./js/utils/global.js";
import axios from "axios";
import { mapState, mapGetters } from "vuex";
export default {
  // name: "Dashboard",
  data() {
    return {
      name: null,
    };
  },
  computed: {
    isAuthLv1,
    isAuthLv2,
    ...mapState({
      isLoggedIn: "isLoggedIn",
    }),
  },
  mounted() {
    /*try {
      axios.get("/api/user").then((response) => {
        //this.name = response.data.email;
        console.log(response.data.email);
      });
    } catch (error) {}
    //*/
  },
  methods: {
    async logout() {
      try {
        axios.post("/api/logout");
        //localStorage.removeItem("isLoggedIn");
        this.$store.dispatch("logout");
        this.$router.push({ name: "Home" });
      } catch (error) {
        this.$store.dispatch("logout");
      }
    },
  },
};
</script>
<style>
nav .router-link-active {
  font-weight: bold;
  color: #c698fa !important;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.2, 0.4, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
